// src/pages/TrustLegal/CookieConsent.jsx
import React, { useState, useEffect } from "react";
import { FaCookieBite } from "react-icons/fa";
import { motion, AnimatePresence } from "framer-motion";

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const cookieDecision = localStorage.getItem("cookieConsent");
    if (cookieDecision) return; // Already accepted or declined
    const timer = setTimeout(() => setVisible(true), 1000);
    return () => clearTimeout(timer);
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookieConsent", "accepted");
    setVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem("cookieConsent", "declined");
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 150, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 150, opacity: 0 }}
          transition={{ duration: 0.6, ease: "easeOut" }}
          className="fixed inset-x-0 bottom-0 bg-[#FFF4E5] text-[#1F2937] p-5 sm:p-6 flex flex-col sm:flex-row items-center justify-between gap-4 shadow-xl border-t border-[#D97706]/20 z-[9999] font-Poppins rounded-t-lg"
          role="dialog"
          aria-live="polite"
        >
          {/* Icon & message */}
          <div className="flex items-start sm:items-center gap-4 flex-1">
            <FaCookieBite
              className="text-[#D97706] animate-bounce mt-1 sm:mt-0"
              size={28}
            />
            <p className="text-sm sm:text-base leading-relaxed">
              Our website uses cookies to enhance your browsing experience,
              analyze traffic, and provide personalized content. By continuing
              to use our site, you agree to our use of cookies.{" "}
              <a
                href="/privacy-policy"
                className="underline hover:text-[#1F2937]/70 transition-colors"
              >
                Learn more
              </a>
            </p>
          </div>

          {/* Action buttons */}
          <div className="flex gap-3 flex-shrink-0 mt-3 sm:mt-0">
            <button
              onClick={handleDecline}
              className="bg-[#6B7280] hover:bg-[#4B5563] rounded-lg px-5 py-2 text-white font-medium text-sm transition-all transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-[#4B5563]"
            >
              Decline
            </button>
            <button
              onClick={handleAccept}
              className="bg-Dark hover:bg-Dark/80 rounded-lg font-semibold px-5 py-2 text-white text-sm transition-all transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-Dark"
            >
              Accept
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieConsent;
